//import {Vue, createApp } from 'vue'
import {createApp } from 'vue'
import App from './App.vue'
import app from './app/app';
import router from './router'
import focus from './directives/focus';
import AInput from '@/components/atk/AInput';
import ASelect from '@/components/atk/ASelect';
import AButtonAccept from '@/components/atk/AButtonAccept';
import AAlertError from '@/components/atk/AAlertError';
import AFormRow from '@/components/atk/AFormRow';
import RouterPark from '@/components/RouterPark';
const vueApp = createApp(App);
vueApp.component('AInput', AInput);
vueApp.component('ASelect', ASelect);
vueApp.component('AButtonAccept', AButtonAccept);
vueApp.component('AAlertError', AAlertError);
vueApp.component('RouterPark', RouterPark);
vueApp.component('AFormRow', AFormRow);
vueApp.directive("focus", focus);
vueApp.use(router).mount('#app');
